/* unplugin-vue-components disabled */import { render } from "./member_preferential_xq_m.vue?vue&type=template&id=0ca8f301&scoped=true"
import script from "./member_preferential_xq_m.vue?vue&type=script&lang=js"
export * from "./member_preferential_xq_m.vue?vue&type=script&lang=js"

import "./member_preferential_xq_m.vue?vue&type=style&index=0&id=0ca8f301&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca8f301"]])

export default __exports__